import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import superbet from "../../Assets/Projects/superbet.png";
import sudoku from "../../Assets/Projects/sudoku.png";
import plc_cloud from "../../Assets/Projects/plc_cloud.png";
import iot_sms from "../../Assets/Projects/iot_sms.png";
import emag from "../../Assets/Projects/emag.png";
import traffic_light from "../../Assets/Projects/traffic_light.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={iot_sms}
              isBlog={false}
              title="IoT SMS notification service for Legacy System"
              description="SCADA System Modernization Overview This project focuses on modernizing legacy SCADA systems by integrating IoT technologies to enhance operational efficiency, reliability, and cost-effectiveness. The system features a web interface, SMS notifications, and cloud data storage."
              ghLink="https://github.com/Adrian-Ureche/IoT-SMS-notification-service-for-Legacy-System"
              demoLink="1Kb_YabzbcdsSYw2QvPnPedG_IiUsMjCy"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={traffic_light}
              isBlog={false}
              title="Smart Traffic Light Intersection"
              description="An Internet of Things system with a Raspberry Pi that receives the length of the queues of cars at an intersection through more ultrasonic sensors and updates the color of the traffic light according to these lengths. Rasberry Pi hosts an OPC UA server with data from  the intersection. This data can be monitored from a mobile dashboard made using Node-Red"
              // ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="1LQFHSBVsOYywkHYtLv0IHbahH3hRxiX9"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plc_cloud}
              isBlog={false}
              title="Communication Interface between PLC and Cloud"
              description="An Internet of Things system was developed using a combination of a PLC, a Raspberry Pi, and a mobile application. The primary objective was to tackle a significant challenge in Industry 4.0, namely communication barriers between devices that use different communication protocols. With this system, an efficient solution was provided as the PLC was able to transmit data to an internet-connected device"
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="1gr4o3I5-rMYOlyB6m9rHh8bKQUEXBM8z"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emag}
              isBlog={false}
              title="Emag Web Scraping Application"
              description="A desktop application, developed in C# .net using Selenium and MySQL, that receive an Emag webpage as input and automatically read the prices of available products. This information is then stored in a database and users can be notified of any price changes for their desired products. This way, users can save time and money by accessing the best deals in the market"
              ghLink="https://github.com/Adrian-Ureche/Emag-Web-Scraping"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={superbet}
              isBlog={false}
              title="Lucky X game auto-player on Superbet"
              description="A desktop application developed in C# .NET using Selenium to interact with the Superbet platform and load solutions for the Lucky X game. Designed the application to generate dynamic solutions based on various inputs, ensuring robust browser automation for tasks like logging in, navigating, and interacting with game elements"
              ghLink="https://github.com/Adrian-Ureche/LuckyX-AutoGen-Matrix-Superbet"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sudoku}
              isBlog={false}
              title="Sudoku Solver - Image processing"
              description="The project uses libraries such as OpenCV for image processing (contour detection, geometric transformations), NumPy for matrix manipulation and Keras for digit recognition using a neural network model. The Sudoku board is extracted from the image, the digits are detected and fed to an automatic solver, and the solution is reintegrated into the original image"
              ghLink="https://github.com/Adrian-Ureche/Sudoku-Solver"
              demoLink="1m9v2zyIPssN-NNYN5PWjtfFXm3kFWY1j"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
